import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  useGetAddressQuery,
  usePostAddressMutation,
  useGetDropDownGroupQuery,
  useLazyGetDropDownGroupValuesQuery,
} from "../../utils/customer/customerTaskTable";
import { getUserToken } from "../../utils/utilityFunctions/localServices";
import { showLoader, hideLoader } from "../../utils/loaderSlice";
import { pushAlert } from "../../utils/alertSlice";
import BackArrowCompoentIcon from "../../assets/images/icons/BackArrowCompoentIcon";
import { ReactComponent as CircleEdit } from "../../assets/images/icons/CircleEdit.svg";
import { ReactComponent as CircleDelete } from "../../assets/images/icons/CircleDelete.svg";
import { ReactComponent as AddField } from "../../assets/images/icons/AddField.svg";
import FieldElements from "../UniversalComponents/FieldElements";
import Button from "../UniversalComponents/DefaultButton";
import LabelComponent from "../UniversalComponents/LabelComponent";
import { useLocation, useNavigate } from "react-router-dom";

const ADDRESS_TYPES = {
  BILLING: "billing",
  SHIPPING: "shipping",
};

const INITIAL_FORM_DATA = {
  billing_addressId: "",
  billing_street1: "",
  billing_street2: "",
  billing_phone: "",
  billing_point_of_contact: "",
  billing_city: "",
  billing_state: "",
  billing_country: "",
  shipping_addressId: "",
  shipping_street1: "",
  shipping_street2: "",
  shipping_phone: "",
  shipping_point_of_contact: "",
  shipping_city: "",
  shipping_state: "",
  shipping_country: "",
};

const AddressFormFields = ({ fields, formData, handleFieldChange, copyBilling, mandatory, vendorId }) => (
  console.log(vendorId, "vendorId in AddressFormFields"),
  (
    <div className="border rounded-md border-[#D2DAE1] p-3 mb-2">
      <div className="flex gap-3">
        <button
          className={`border rounded-md px-2 p-1 text-14 font-500 ${
            formData.activeType === ADDRESS_TYPES.BILLING
              ? "bg-[#1D4469] text-white border-[#1D4469]"
              : "bg-white text-[#47637D] border-[#47637D]"
          }`}
          onClick={() => formData.setActiveType(ADDRESS_TYPES.BILLING)}
        >
          Billing Address
        </button>
        <button
          className={`border rounded-md px-2 p-1 text-14 font-500 ${
            formData.activeType === ADDRESS_TYPES.SHIPPING
              ? "bg-[#1D4469] text-white border-[#1D4469]"
              : "bg-white text-[#47637D] border-[#47637D]"
          }`}
          onClick={() => formData.setActiveType(ADDRESS_TYPES.SHIPPING)}
        >
          Shipping Address
        </button>
        {formData.activeType === ADDRESS_TYPES.SHIPPING && (
          <label className="flex items-center text-sm text-[#666666] mr-3">
            <input
              type="checkbox"
              checked={formData.copyBilling}
              onChange={formData.handleCopyBillingToShipping}
              className="mr-2 h-4 w-4 rounded border-gray-400 bg-white text-[#00BA00] focus:ring-0 focus:outline-none"
            />
            Same as Billing Address
          </label>
        )}
      </div>
      <div className="grid grid-cols-2 gap-x-40 gap-y-2 col-span-2 min-h-0 grow mt-5">
        {fields
          .filter((item) => !item.hide)
          .map((field) => (
            <div key={field.id} className={`flex flex-row col-span-${field.colspan ?? "1"} gap-10 items-center`}>
              {!field.noLabel && (
                <LabelComponent
                  labelText={field.label}
                  htmlFor={field.label}
                  size="small"
                  isMandatory={field?.isMandatory}
                  className="block mb-1 text-12 font-400 text-[#666] w-1/3 items-center"
                />
              )}
              <div className="flex min-w-0 grow h-full items-center">
                <FieldElements
                  id={field.id}
                  name={field.id}
                  label={field.label}
                  value={formData.formData[field.id] || ""}
                  onChange={handleFieldChange}
                  type={field.type}
                  formData={formData.formData}
                  className={field.type === "textArea" ? "h-12" : ""}
                  useFetchHook={field.useFetchHook}
                  hookPayload={field.hookPayload}
                  labelKey="label"
                  valueKey="id"
                  valueKeyBased
                  placeholder={field.placeholder}
                  mandatory={field.mandatory}
                  disabled={false}
                />
              </div>
            </div>
          ))}
      </div>
      <div className="gap-3 flex pt-5">
        <Button
          variant="secondary"
          onClick={() => formData.setIsShowMode(false)}
          className="whitespace-nowrap px-4 bg-[white] border-solid hover:bg-[white] hover:border-[#004EFF] hover:text-[#004EFF]"
        >
          CANCEL
        </Button>
        <Button
          onClick={formData.handleAddressSubmit}
          variant="primary"
          type="submit"
          className="bg-[#5489FF] hover:bg-[#004EFF]"
        >
          {(formData.editData?.row_id && formData.editAddressData) || vendorId ? "UPDATE" : "SAVE"}
        </Button>
      </div>
    </div>
  )
);

const AddressDisplay = ({ groupedAddresses, handleEditAddress, handleMarkAsDefault, editingGroupId, isShowMode }) => (
  <div className="flex flex-col rounded-md border border-[#D2DAE1] min-h-0 grow mb-2">
    <div className="flex border-b p-3 text-16 font-600 text-[#505E70]">
      <div className="w-1/2">Billing Address</div>
      <div className="w-1/2">Shipping Address</div>
    </div>
    <div className="overflow-y-auto thinscrollbar">
      {Object.entries(groupedAddresses)
        .sort(([, a], [, b]) => {
          const aIsPrimary = a.billing?.is_primary === 1 || a.shipping?.is_primary === 1 ? 1 : 0;
          const bIsPrimary = b.billing?.is_primary === 1 || b.shipping?.is_primary === 1 ? 1 : 0;
          return bIsPrimary - aIsPrimary;
        })
        .map(([groupId, group]) => (
          <div key={groupId} className={`p-3`}>
            <div
              className={`w-full flex items-start relative group hover:bg-[#F4F4F4] transition-colors duration-200 rounded-md p-3 min-h-20 ${groupId === editingGroupId && isShowMode ? "opacity-50 pointer-events-none bg-[#F4F4F4] rounded" : ""}`}
            >
              <div className="w-1/2 h-full flex flex-col justify-start">
                <p className="text-[#383838] text-16 font-400 pe-8">{group.billing?.point_of_contact || ""}</p>
                <p className="text-[#666] text-14 font-400 pe-8 whitespace-normal break-all">
                  {group.billing?.address_line1 || ""} <br />
                  {group.billing?.address_line2 || ""}
                </p>
                <p className="text-[#666] text-14 font-400 pe-8 whitespace-normal break-all">
                  {group.billing?.city || ""} {group.billing?.state || ""} {group.billing?.country || ""}
                </p>
                <p className="text-[#666] text-14 font-400 pe-8 whitespace-normal break-all">
                  {group.billing?.phone_number || ""}
                </p>
              </div>
              <div className="flex w-1/2 h-full relative">
                <div className="flex justify-between pe-8 w-full h-full">
                  <div className="h-full flex flex-col justify-start">
                    <p className="text-[#383838] text-16 font-400 pe-8">{group.shipping?.point_of_contact || ""}</p>
                    <p className="text-[#666] text-14 font-400 pe-8 whitespace-normal break-all">
                      {group.shipping?.address_line1 || ""} <br />
                      {group.shipping?.address_line2 || ""}
                    </p>
                    <p className="text-[#666] text-14 font-400 pe-8 whitespace-normal break-all">
                      {group.shipping?.city || ""} {group.shipping?.state || ""} {group.shipping?.country || ""}
                    </p>
                    <p className="text-[#666] text-14 font-400 pe-8 whitespace-normal break-all">
                      {group.shipping?.phone_number || ""}
                    </p>
                  </div>
                  <div className="flex flex-col justify-between items-end h-full min-w-[120px] absolute right-0 top-0 bottom-0">
                    <label
                      className={`text-sm ${group.billing?.is_primary === 1 || group.shipping?.is_primary === 1 ? "text-[#2999BC] font-medium" : "text-[#666666]"}`}
                    >
                      <input
                        type="checkbox"
                        checked={group.billing?.is_primary === 1 || group.shipping?.is_primary === 1}
                        onChange={() => handleMarkAsDefault(group)}
                        className={`mr-2 h-4 w-4 rounded bg-white focus:ring-0 focus:outline-none ${
                          group.billing?.is_primary === 1 || group.shipping?.is_primary === 1
                            ? "border-[#2999BC] text-[#2999BC]"
                            : "border-gray-400 text-gray-500"
                        }`}
                        disabled={groupId === editingGroupId && isShowMode}
                      />
                      Default Address
                    </label>
                    <div className="opacity-0 group-hover:opacity-100 flex gap-2 transition-opacity duration-300">
                      <button
                        onClick={() => handleEditAddress(group)}
                        disabled={groupId === editingGroupId && isShowMode}
                      >
                        <CircleEdit />
                      </button>
                      {false && (
                        <button disabled={groupId === editingGroupId && isShowMode}>
                          <CircleDelete />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  </div>
);

const VendorAddress = ({
  vendorUUID,
  billingAddressData = {},
  shippingAddressData = {},
  editData,
  handleBackButtonClick,
  vendorName,
  editSection,
}) => {
  const userToken = getUserToken();
  const dispatch = useDispatch();
  const location = useLocation();
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [activeType, setActiveType] = useState(ADDRESS_TYPES.BILLING);
  const [isShowMode, setIsShowMode] = useState(location.state?.isShowMode ?? false);
  const [copyBilling, setCopyBilling] = useState(false);
  const [isDefaultAddress, setIsDefaultAddress] = useState(false);
  const [editAddressData, setEditAddressData] = useState(null);
  const [editingGroupId, setEditingGroupId] = useState(null);
  const vendorId = editData?.row_id || editData?.id || location?.state?.vendorData?.id || vendorUUID;

  const navigate = useNavigate();

  const { data: groups, isLoading: isGroupsLoading } = useGetDropDownGroupQuery(userToken);
  const {
    data: addressData,
    isLoading: isAddressLoading,
    isSuccess,
    isError,
    error,
    refetch,
  } = useGetAddressQuery(
    {
      UUID: vendorId,
      token: userToken,
    },
    {
      skip: !vendorId,
    }
  );

  const [
    postAddress,
    { isLoading: isPostLoading, isSuccess: isPostSuccess, isError: isPostError, data: postResponse },
  ] = usePostAddressMutation();

  console.log("VendorAddress location.state:", location.state);
  console.log("VendorAddress formData:", formData);

  const addressFields = {
    [ADDRESS_TYPES.BILLING]: [
      {
        label: "Point of Contact",
        id: "billing_point_of_contact",
        type: "text",
        placeholder: "Enter Point of Contact",
        isMandatory: true,
      },
      {
        label: "Address",
        id: "billing_street1",
        type: "textArea",
        placeholder: "Billing Address 1",
        isMandatory: true,
      },
      { label: "", id: "", type: "", placeholder: "", noLabel: true, noValue: true },
      { label: "", id: "billing_street2", type: "textArea", placeholder: "Billing Address 2" },
      { label: "City", id: "billing_city", type: "text", placeholder: "Enter City" },
      {
        label: "State",
        id: "billing_state",
        type: "select",
        placeholder: "Select State",
        useFetchHook: useLazyGetDropDownGroupValuesQuery,
        hookPayload:
          // { UUID: groups?.data?.find((item) => item.label === "state")?.id },
          { field_name: "state" },
      },
      {
        label: "Country",
        id: "billing_country",
        type: "select",
        placeholder: "Select Country",
        useFetchHook: useLazyGetDropDownGroupValuesQuery,
        hookPayload:
          // { UUID: groups?.data?.find((item) => item.label === "country")?.id },
          { field_name: "country" },
      },
      { label: "Phone Number", id: "billing_phone", type: "text", placeholder: "Enter Phone Number" },
    ],
    [ADDRESS_TYPES.SHIPPING]: [
      {
        label: "Point of Contact",
        id: "shipping_point_of_contact",
        type: "text",
        placeholder: "Enter Point of Contact",
        isMandatory: true,
      },
      {
        label: "Address",
        id: "shipping_street1",
        type: "textArea",
        placeholder: "Shipping Address 1",
        isMandatory: true,
      },
      { label: "", id: "", type: "", placeholder: "", noLabel: true, noValue: true },
      { label: "", id: "shipping_street2", type: "textArea", placeholder: "Shipping Address 2" },
      { label: "City", id: "shipping_city", type: "text", placeholder: "Enter City" },
      {
        label: "State",
        id: "shipping_state",
        type: "select",
        placeholder: "Select State",
        useFetchHook: useLazyGetDropDownGroupValuesQuery,
        hookPayload: { field_name: "state" },
      },
      {
        label: "Country",
        id: "shipping_country",
        type: "select",
        placeholder: "Select Country",
        useFetchHook: useLazyGetDropDownGroupValuesQuery,
        hookPayload: { field_name: "country" },
      },
      { label: "Phone Number", id: "shipping_phone", type: "text", placeholder: "Enter Phone Number" },
    ],
  };

  // Open form if no address data
  useEffect(() => {
    if (isSuccess && addressData?.data?.length === 0 && !isShowMode) {
      setIsShowMode(true);
    }
  }, [isSuccess, addressData, isShowMode]);

  useEffect(() => {
    const addressDataFromState = location.state?.addressData;
    console.log("VendorAddress useEffect addressDataFromState:", addressDataFromState);
    if (addressDataFromState && location.state?.activeTab === "address" && location.state?.isShowMode) {
      setIsShowMode(true);
      setEditAddressData({
        billing: addressDataFromState.billing,
        shipping: addressDataFromState.shipping,
      });
      const newFormData = {
        ...INITIAL_FORM_DATA,
        ...(addressDataFromState.billing && {
          billing_addressId: addressDataFromState.billing.id || "",
          billing_point_of_contact: addressDataFromState.billing.point_of_contact || "",
          billing_street1: addressDataFromState.billing.address_line1 || "",
          billing_street2: addressDataFromState.billing.address_line2 || "",
          billing_phone: addressDataFromState.billing.phone_number || "",
          billing_city: addressDataFromState.billing.city || "",
          billing_state: addressDataFromState.billing.state || "",
          billing_country: addressDataFromState.billing.country || "",
        }),
        ...(addressDataFromState.shipping && {
          shipping_addressId: addressDataFromState.shipping.id || "",
          shipping_point_of_contact: addressDataFromState.shipping.point_of_contact || "",
          shipping_street1: addressDataFromState.shipping.address_line1 || "",
          shipping_street2: addressDataFromState.shipping.address_line2 || "",
          shipping_phone: addressDataFromState.shipping.phone_number || "",
          shipping_city: addressDataFromState.shipping.city || "",
          shipping_state: addressDataFromState.shipping.state || "",
          shipping_country: addressDataFromState.shipping.country || "",
        }),
      };
      setFormData(newFormData);
      console.log("VendorAddress useEffect setFormData:", newFormData);
      setActiveType(ADDRESS_TYPES.BILLING);
      setIsDefaultAddress(
        addressDataFromState.billing?.is_primary === 1 || addressDataFromState.shipping?.is_primary === 1
      );
      setEditingGroupId(
        addressDataFromState.billing?.address_group_id || addressDataFromState.shipping?.address_group_id || ""
      );
      setCopyBilling(
        addressDataFromState.billing &&
          addressDataFromState.shipping &&
          Object.keys(addressDataFromState.billing)
            .filter((key) => key !== "id" && key !== "is_primary" && key !== "address_group_id")
            .every((key) => addressDataFromState.billing[key] === addressDataFromState.shipping[key])
      );
    } else {
      setFormData(INITIAL_FORM_DATA);
      setIsShowMode(location.state?.isShowMode ?? false);
      setEditAddressData(null);
      setEditingGroupId(null);
      setCopyBilling(false);
      setIsDefaultAddress(false);
      setActiveType(ADDRESS_TYPES.BILLING);
    }
  }, [location.state]);

  useEffect(() => {
    if (addressData?.data) {
      const billing =
        addressData.data.find((e) => e.address_type === ADDRESS_TYPES.BILLING && e.is_primary === 1) ||
        addressData.data.find((e) => e.address_type === ADDRESS_TYPES.BILLING);
      const shipping =
        addressData.data.find((e) => e.address_type === ADDRESS_TYPES.SHIPPING && e.is_primary === 1) ||
        addressData.data.find((e) => e.address_type === ADDRESS_TYPES.SHIPPING);
      const newFormData = { ...INITIAL_FORM_DATA };

      if (billing) {
        newFormData.billing_addressId = billing.id || "";
        newFormData.billing_point_of_contact = billing.point_of_contact || "";
        newFormData.billing_street1 = billing.address_line1 || "";
        newFormData.billing_street2 = billing.address_line2 || "";
        newFormData.billing_phone = billing.phone_number || "";
        newFormData.billing_city = billing.city || "";
        newFormData.billing_state = billing.state || "";
        newFormData.billing_country = billing.country || "";
      }

      if (shipping) {
        newFormData.shipping_addressId = shipping.id || "";
        newFormData.shipping_point_of_contact = shipping.point_of_contact || "";
        newFormData.shipping_street1 = shipping.address_line1 || "";
        newFormData.shipping_street2 = shipping.address_line2 || "";
        newFormData.shipping_phone = shipping.phone_number || "";
        newFormData.shipping_city = shipping.city || "";
        newFormData.shipping_state = shipping.state || "";
        newFormData.shipping_country = shipping.country || "";
      }

      setCopyBilling(
        billing &&
          shipping &&
          Object.keys(billing)
            .filter((key) => key !== "id" && key !== "is_primary" && key !== "address_group_id")
            .every((key) => billing[key] === shipping[key])
      );
      setFormData(newFormData);
      setIsDefaultAddress(billing?.is_primary === 1 || shipping?.is_primary === 1);
    }
  }, [addressData]);

  useEffect(() => {
    dispatch(isAddressLoading ? showLoader() : hideLoader());
    if (isSuccess) console.log("Address fetched successfully:", addressData);
    if (isError) {
      dispatch(
        pushAlert({
          message: error?.data?.message || error?.error || "Failed to fetch address data.",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isAddressLoading, isSuccess, isError, error, dispatch]);

  useEffect(() => {
    if (isPostLoading) dispatch(showLoader());
    else dispatch(hideLoader());

    if (isPostSuccess) {
      dispatch(
        pushAlert({
          message: postResponse?.message || "Address saved successfully",
          type: "success",
          visible: true,
        })
      );
      refetch();
      setIsShowMode(false);
      setEditingGroupId(null);
      setFormData(INITIAL_FORM_DATA);
      setCopyBilling(false);
      setIsDefaultAddress(false);
      setEditAddressData(null);
    }

    if (isPostError) {
      dispatch(
        pushAlert({
          message: postResponse?.message || "Failed to save address",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isPostLoading, isPostSuccess, isPostError, postResponse, dispatch, refetch]);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value || "" }));
  };

  const handleCopyBillingToShipping = (e) => {
    const isChecked = e.target.checked;
    setCopyBilling(isChecked);
    setFormData((prev) => ({
      ...prev,
      ...(isChecked
        ? {
            shipping_street1: prev.billing_street1,
            shipping_street2: prev.billing_street2,
            shipping_phone: prev.billing_phone,
            shipping_point_of_contact: prev.billing_point_of_contact,
            shipping_city: prev.billing_city,
            shipping_state: prev.billing_state,
            shipping_country: prev.billing_country,
          }
        : {
            shipping_street1: "",
            shipping_street2: "",
            shipping_phone: "",
            shipping_point_of_contact: "",
            shipping_city: "",
            shipping_state: "",
            shipping_country: "",
          }),
    }));
  };

  const handleAddressSubmit = (e) => {
    e.preventDefault();
    if (isPostLoading) return;
    const requiredFields = [
      { key: `${activeType}_point_of_contact`, message: "Point of contact is required" },
      { key: `${activeType}_street1`, message: "Address line 1 is required" },
    ];

    for (const field of requiredFields) {
      if (!formData[field.key]?.trim()) {
        dispatch(
          pushAlert({
            message: field.message,
            type: "danger",
            visible: true,
          })
        );
        return;
      }
    }

    const createAddressPayload = (type) => ({
      ...(formData[`${type}_addressId`] && { addressId: formData[`${type}_addressId`] }),
      point_of_contact: formData[`${type}_point_of_contact`] || "",
      address_line1: formData[`${type}_street1`] || "",
      address_line2: formData[`${type}_street2`] || "",
      phone_number: formData[`${type}_phone`] || "",
      city: formData[`${type}_city`] || "",
      state: formData[`${type}_state`] || "",
      country: formData[`${type}_country`] || "",
      is_primary: isDefaultAddress && activeType === type ? 1 : 0,
    });

    postAddress({
      UUID: vendorId,
      token: userToken,
      body: {
        billingAddress: createAddressPayload(ADDRESS_TYPES.BILLING),
        shippingAddress: createAddressPayload(ADDRESS_TYPES.SHIPPING),
      },
    });
  };

  const handleAddNewAddress = () => {
    setIsShowMode(true);
    setEditAddressData(null);
    setFormData(INITIAL_FORM_DATA);
    setCopyBilling(false);
    setIsDefaultAddress(false);
    setActiveType(ADDRESS_TYPES.BILLING);
    setEditingGroupId(null);
  };

  const handleEditAddress = (group) => {
    setIsShowMode(true);
    setEditAddressData({ billing: group.billing, shipping: group.shipping });
    setFormData({
      ...INITIAL_FORM_DATA,
      ...(group.billing && {
        billing_addressId: group.billing.id || "",
        billing_point_of_contact: group.billing.point_of_contact || "",
        billing_street1: group.billing.address_line1 || "",
        billing_street2: group.billing.address_line2 || "",
        billing_phone: group.billing.phone_number || "",
        billing_city: group.billing.city || "",
        billing_state: group.billing.state || "",
        billing_country: group.billing.country || "",
      }),
      ...(group.shipping && {
        shipping_addressId: group.shipping.id || "",
        shipping_point_of_contact: group.shipping.point_of_contact || "",
        shipping_street1: group.shipping.address_line1 || "",
        shipping_street2: group.shipping.address_line2 || "",
        shipping_phone: group.shipping.phone_number || "",
        shipping_city: group.shipping.city || "",
        shipping_state: group.shipping.state || "",
        shipping_country: group.shipping.country || "",
      }),
    });
    setActiveType(ADDRESS_TYPES.BILLING);
    setIsDefaultAddress(group.billing?.is_primary === 1 || group.shipping?.is_primary === 1);
    setEditingGroupId(group.billing?.address_group_id || group.shipping?.address_group_id || "");
    setCopyBilling(
      group.billing &&
        group.shipping &&
        Object.keys(group.billing)
          .filter((key) => key !== "id" && key !== "is_primary" && key !== "address_group_id")
          .every((key) => group.billing[key] === group.shipping[key])
    );
  };

  const handleMarkAsDefault = (group) => {
    const groupId = group.billing?.address_group_id || group.shipping?.address_group_id || "";
    const createPayload = (address, isPrimary) => ({
      addressId: address?.id || "",
      address_group_id: groupId,
      point_of_contact: address?.point_of_contact || "",
      address_line1: address?.address_line1 || "",
      address_line2: address?.address_line2 || "",
      phone_number: address?.phone_number || "",
      city: address?.city || "",
      state: address?.state || "",
      country: address?.country || "",
      is_primary: isPrimary ? 1 : 0,
    });

    const otherGroups = Object.values(groupedAddresses).filter(
      (g) => g !== group && (g.billing?.is_primary === 1 || g.shipping?.is_primary === 1)
    );

    Promise.all(
      otherGroups.map((otherGroup) =>
        postAddress({
          UUID: vendorId,
          token: userToken,
          body: {
            billingAddress: createPayload(otherGroup.billing, false),
            shippingAddress: createPayload(otherGroup.shipping, false),
          },
        })
      )
    )
      .then(() =>
        postAddress({
          UUID: vendorId,
          token: userToken,
          body: {
            billingAddress: createPayload(group.billing, true),
            shippingAddress: createPayload(group.shipping, true),
          },
        })
      )
      .catch((error) => console.error("Error updating address:", error));
  };

  const groupedAddresses = addressData?.data?.reduce((acc, address) => {
    const groupId = address.address_group_id;
    acc[groupId] = acc[groupId] || { billing: null, shipping: null };
    acc[groupId][address.address_type] = address;
    return acc;
  }, {});

  const hasAddressData = groupedAddresses && Object.keys(groupedAddresses).length > 0;

  return (
    <div className="pl-4 h-full">
      <div className="flex flex-col h-full">
        <div className="flex items-center px-2 py-2 justify-between">
          <div className="flex">
            <button
              onClick={() => {
                if (location.pathname === "/add-vendor") {
                  navigate("/vendors");
                } else {
                  navigate(`/vendor-profile/${vendorId}`, {
                    state: { isEditMode: true },
                  });
                }
              }}
            >
              <BackArrowCompoentIcon />
            </button>
            <h3 className="text-16 font-600 text-[#383838] mx-2 items-center">
              <span className="items-center text-[rgba(56,56,56,0.6)] text-16 font-500">Vendor &gt; </span>
              {vendorName}
            </h3>
          </div>
          {!isShowMode && (
            <button className="group cursor-pointer border border-[#D2DAE1] hover:border-[#004EFF] rounded-md flex items-center gap-2 px-3 py-1.5">
              <AddField className="w-4 h-4 fill-[#666] group-hover:fill-[#004EFF]" />
              <span className="text-base font-normal text-[#666] group-hover:text-[#004EFF]">Add New</span>
            </button>
          )}
        </div>

        {console.log(vendorId, "vendorId in return")}

        {/* eslint-disable-next-line no-undef */}
        {(isShowMode || !hasAddressData) && (
          <AddressFormFields
            fields={addressFields[activeType]}
            formData={{
              formData,
              activeType,
              setActiveType,
              copyBilling,
              handleCopyBillingToShipping,
              setIsShowMode,
              editData,
              editAddressData,
              handleAddressSubmit,
            }}
            handleFieldChange={handleFieldChange}
            copyBilling={copyBilling}
            mandatory={true}
            vendorId={vendorId}
          />
        )}

        {hasAddressData && (
          <AddressDisplay
            groupedAddresses={groupedAddresses}
            handleEditAddress={handleEditAddress}
            handleMarkAsDefault={handleMarkAsDefault}
            editingGroupId={editingGroupId}
            isShowMode={isShowMode}
          />
        )}
      </div>
    </div>
  );
};

export default VendorAddress;
